import { render, staticRenderFns } from "./ordersDetails.vue?vue&type=template&id=2ea225e4&scoped=true&"
import script from "./ordersDetails.vue?vue&type=script&lang=js&"
export * from "./ordersDetails.vue?vue&type=script&lang=js&"
import style0 from "./ordersDetails.vue?vue&type=style&index=0&id=2ea225e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea225e4",
  null
  
)

export default component.exports